<template>
  <div>
    <div v-if="!loading">
      <div class="applicant-jobs-container">
        <div v-if="bodyList">
          <FilterJob
            v-on:filterHandler="filterHandler"
            :firstTitle="'Jobs'"
            :secondTitle="'Type of Employment'"
            :thirdTitle="'Status'"
            :firstOptions="firstOptions"
            :secondOptions="secondOptions"
            :thirdOptions="thirdOptions"
            :firstSelectedValue="firstSelectedValue"
            :secondSelectedValue="secondSelectedValue"
            :thirdSelectedValue="thirdSelectedValue"
          />
        </div>

        <div>
          <ListTable
            :headList="headList"
            :bodyList="currentJobsList"
            :emptyStateTitle="'Applications'"
            :emptyListDescription="'Applications Not Avaialable - Start by Applying to Jobs'"
            v-if="!loading"
            v-on:viewHandler="linkToJobDetails"
          />
        </div>
      </div>

      <div class="redirect-to-jobs">
        <button @click="redirectToJobs()">Apply for Jobs</button>
      </div>

      <div class="pagination">
        <Pagination
          v-if="bodyList !== null && bodyList.length > 0"
          v-bind:itemsPerPage="itemsPerPage"
          v-bind:totalJobs="activeListLength"
          v-bind:currentPage="currentPage"
          v-on:paginate="paginate"
        />
      </div>

    </div>

    <div v-if="loading">
      <FilterJob
        v-on:filterHandler="filterHandler"
        :firstTitle="'Jobs'"
        :secondTitle="'Type of Employment'"
        :thirdTitle="'Status'"
        :firstOptions="firstOptions"
        :secondOptions="secondOptions"
        :thirdOptions="thirdOptions"
        :firstSelectedValue="firstSelectedValue"
        :secondSelectedValue="secondSelectedValue"
        :thirdSelectedValue="thirdSelectedValue"
        class="applicant-jobs-container"
      />

      <!-- Loader Component-->
      <div class="loader" v-if="loading">
        <Loader />
      </div>

    </div>
  </div>
</template>

<script>
import ListTable from '../../components/body/ListTable.vue';
import FilterJob from '../../components/body/FilterJob.vue';
import threeDotsIcon from '../../assets/images/tableDots.png';
import Pagination from '../../components/Pagination.vue';
import Loader from '../../components/body/Loader.vue';

export default {
  name: 'ApplicantApplicationsList',
  components: {
    ListTable,
    FilterJob,
    Pagination,
    Loader
  },
  data() {
    return {
      loading: true,
      myApps: null,
      myApplications: this.$store.state.userData.myApplications,
      headList: [
        {
          text: 'JOB TITLE',
        },
        {
          text: 'COMPANY',
        },
        {
          text: 'LOCATION',
        },
        {
          text: 'EMPLOYMENT TYPE',
        },
        {
          text: 'STATUS',
        },
        {
          text: 'DEADLINE',
        },
        {
          text: '',
        },
      ],
      bodyList: null,

      firstOptions: [
        { name: 'All Jobs', value: 'allJobs', selected: true },
        { name: 'Technology', value: 'Technology' },
        { name: 'Education', value: 'Education' },
        { name: 'Product Design', value: 'Product Design' },
        { name: 'Product Management', value: 'Product Management' },
        { name: 'Project Management', value: 'Project Management' },
        { name: 'Administration', value: 'Administration' },
        { name: 'Operations', value: 'Operations' },
        { name: 'Sales', value: 'Sales' },
        { name: 'Marketing', value: 'Marketing' },
        { name: 'Customer Service', value: 'Customer Service' },
        { name: 'Human Resources', value: 'Human Resources' },
        { name: 'Creative & Design', value: 'Creative and Design' },
        { name: 'Media & Communications', value: 'Media and Communications' },
        { name: 'Health & Wellness', value: 'Health and Wellness' },
        { name: 'Hospitality & Tourism', value: 'Hospitality and Tourism' },
        { name: 'Arts & Entertainment', value: 'Arts and Entertainment' },
        { name: 'Science & Research', value: 'Science and Research' },
        { name: 'Agriculture', value: 'Agriculture' },
        { name: 'Finance', value: 'Finance' },
        { name: 'Supply Chain', value: 'Supply Chain' },
        { name: 'Engineering', value: 'Engineering' },
        { name: 'Building & Construction', value: 'Building and Construction' },
        {
          name: 'Logistics & Transportation',
          value: 'Logistics and Transportation',
        },
        { name: 'Legal', value: 'Legal' },
        { name: 'Energy & Utilities', value: 'Energy and Utilities' },
        { name: 'Telecommunications', value: 'Telecommunications' },
        {
          name: 'Petroleum & Petrochemicals',
          value: 'Petroleum and Petrochemicals',
        },
        {
          name: 'Furniture & Interior Design',
          value: 'Furniture and Interior Design',
        },
        { name: 'Manufacturing', value: 'Manufacturing' },
        { name: 'Healthcare', value: 'Healthcare' },
        { name: 'Others', value: 'Others' },
      ],
      secondOptions: [
        {
          id: 1,
          name: 'All Employment Types',
          value: 'allEmployment',
        },
        { id: 2, name: 'Full Time', value: 'Full Time' },
        { id: 3, name: 'Full Time - Remote', value: 'Full Time - Remote' },
        { id: 4, name: 'Full Time - Hybrid', value: 'Full Time - Hybrid' },
        { id: 5, name: 'Part Time', value: 'Part Time' },
        { id: 6, name: 'Part Time - Remote', value: 'Part Time - Remote' },
        { id: 7, name: 'Part Time - Hybrid', value: 'Part Time - Hybrid' },
        { id: 8, name: 'Contract', value: 'Contract' },
        { id: 9, name: 'Internship', value: 'Internship' },
      ],
      thirdOptions: [
        { id: 1, name: 'All Status', value: 'allStatus', selected: true },
        { id: 2, name: 'In Review', value: 'in-review' },
        { id: 3, name: 'Shortlisted', value: 'shortlisted' },
        {
          id: 4,
          name: 'Scheduled for Interview',
          value: 'scheduled-for-interview',
        },
        { id: 5, name: 'Interviewing', value: 'interviewing' },
        { id: 6, name: 'Hired', value: 'hired' },
        { id: 7, name: 'Declined', value: 'declined' },
      ],
      firstSelectedValue: 'allJobs',
      secondSelectedValue: 'allEmployment',
      thirdSelectedValue: 'allStatus',
      threeDotsIcon,

      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  async mounted() {
    this.getMyApplicationsJobs();
  },
  methods: {
    getMyApplicationsJobs() {
    // Get all Applications and Aggregate Job details for each application
      this.loading = true;
      this.myApps = [];
      // this.myApplications = this.$store.state.userData.myApplications;
      let body = {};

      if(this.myApplications?.length > 0) {
        this.myApplications.forEach(async (app) => {
          body = {
            jobTitle: app.jobInfo && app.jobInfo.title
                  ? app.jobInfo.title
                  : '—',
            company: app.jobInfo && app.jobInfo.companyName
                  ? app.jobInfo.companyName
                  : '—',
            location:
                (app.jobInfo && app.jobInfo.city) && (app.jobInfo && app.jobInfo.state)
                  ? `${app.jobInfo.city}, ${app.jobInfo.state}`
                  : '—',
            employmentType: app.jobInfo && app.jobInfo.employmentType
                ? app.jobInfo.employmentType
                : '—',
            category: app.jobInfo && app.jobInfo.category
                ? app.jobInfo.category
                : '—',
            status: app.status,
            deadline:
                app.jobInfo && app.jobInfo.deadline
                  ? new Date(app.jobInfo.deadline).toDateString()
                  : '—',
            threeDotsIcon: threeDotsIcon,
            id: app.jobId
          };

          this.myApps.push(body);

          if(this.myApps?.length === this.myApplications?.length){
            this.bodyList = this.myApps;
          }
        });

        // Always return the newest/most recent applications data
        this.myApps.reverse();

        this.loading = false;

      } else {
        this.bodyList = [];
        this.loading = false;
      }
    },
    linkToJobDetails(jobId) {
      this.$emit('setJobId', jobId);
    },
    filterHandler(selectedOptions) {
      this.currentPage = 1;

      const { firstOption, secondOption, thirdOption } = selectedOptions;

      // Start with all applications
      let result = [...this.myApps];

      // --- CATEGORY FILTER (firstOption) ---
      if (firstOption !== null && firstOption !== 'allJobs') {
        result = result.filter(app => app.category === firstOption);
      }

      // --- EMPLOYMENT TYPE FILTER (secondOption) ---
      if (secondOption !== null && secondOption !== 'allEmployment') {
        result = result.filter(app => app.employmentType === secondOption);
      }

      // --- STATUS FILTER (thirdOption) ---
      if (thirdOption !== null && thirdOption !== 'allStatus') {
        result = result.filter(app => app.status === thirdOption);
      }

      this.bodyList = result;
      return result;
    },
    // Dynamic Multi-Select Filter Handlers
    multiFilterHandler(selectedOptions) {
      this.currentPage = 1;

      // Mapping of filter keys to the object field and "all" value
      const filterConfig = {
        firstOption: { field: 'category', allValue: 'allJobs' },
        secondOption: { field: 'employmentType', allValue: 'allEmployment' },
        thirdOption: { field: 'status', allValue: 'allStatus' }
      };

      // Start with all applications
      let result = [...this.myApps];

      // Apply all filters dynamically
      for (const [optionKey, config] of Object.entries(filterConfig)) {
        const selectedValue = selectedOptions[optionKey];

        if (!selectedValue) continue; // skip null/undefined/empty

        // Handle multi-select (array) or single value
        const valuesToFilter = Array.isArray(selectedValue) ? selectedValue : [selectedValue];

        // Skip if it contains only the "all" value
        if (valuesToFilter.includes(config.allValue)) continue;

        result = result.filter(app => valuesToFilter.includes(app[config.field]));
      }

      this.bodyList = result;
      return result;
    },
    redirectToJobs() {
      this.$emit('redirectToJobs', 'Jobs');
    },
    paginate(pageNumber) {
      this.currentPage = pageNumber;
    }
  },
  computed: {
    indexOfLastJob() {
      return this.currentPage * this.itemsPerPage;
    },
    indexOfFirstJob() {
      return this.indexOfLastJob - this.itemsPerPage;
    },
    currentJobsList() {
      return this.bodyList?.slice(this.indexOfFirstJob, this.indexOfLastJob);
    },
    activeListLength() {
      return this.bodyList?.length;
    }
  },
};
</script>
<style scoped>
  .applicant-jobs-container {
    background: var(--white);
    border: 0.5px solid rgba(201, 201, 201, 0.35);
    box-sizing: border-box;
    box-shadow: 0px 14px 24px rgba(9, 44, 76, 0.1);
    border-radius: 10px 10px;
  }
  .redirect-to-jobs {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    margin: 20px;
  }
  .redirect-to-jobs button {
    width: 205px;
    height: 54px;
    background: var(--colorPrimary);
    color: var(--white);
    border-radius: 5px;
    margin-top: 25px;
  }
  .pagination {
    margin-top: 30px;
    margin-bottom: 20px;
    display: flex;
    justify-content: right;
    align-items: center;
  }
</style>
